app.dropdowns = {
    settings: {
        $btn: $('.dropdown--trigger'),
        $btnmobile: $('.dropdown--trigger__mobile'),
        $content: $('.dropdown--content'),
        $wrapper: $('.dropdown--wrapper')
    },

    init: function() {
        app.dropdowns.settings.$btnmobile.on('click', function(e){
            if ($(window).width() < 576) {
                $(this).closest(app.dropdowns.settings.$wrapper).find(app.dropdowns.settings.$content).slideToggle(100);
                $(this).closest(app.dropdowns.settings.$wrapper).find('.icon-after').toggleClass("icon--up");
            }
        });
        app.dropdowns.settings.$btn.on('click', function(e){
            $(this).closest(app.dropdowns.settings.$wrapper).find(app.dropdowns.settings.$content).slideToggle(100);
            $(this).closest(app.dropdowns.settings.$wrapper).find('.icon-after').toggleClass("icon--up");
        });
    }
};

// app.dropdowns = {
//     settings: {
//         $el: $('.dropdown'),
//         showClass: 'dropdown--show'
//     },

//     init: function () {
//         app.dropdowns.settings.$el.on('click', function (event) {
//             var $this = $(this);

//             event.stopPropagation();

//             if (app.settings.$html.hasClass('touch') || $this.data('dropdownTrigger')) {
//                 app.dropdowns.settings.$el.not($this).removeClass(app.dropdowns.settings.showClass);
//                 $this.toggleClass(app.dropdowns.settings.showClass);
//             }
//         });

//         app.settings.$body
//             .on('keydown', function(event){
//                 if (event.keyCode === 27) {
//                     $('.dropdown').removeClass('dropdown--show');
//                 }
//             })
//             .on('click', function () {
//                 $('.dropdown').removeClass('dropdown--show');
//             });
//     }
// };